import { onDocumentReady } from '../../utils/stacked-slider';
import initNieruchomoscSlider from '../../utils/init-nieruchomosc-slider';

onDocumentReady( () => {
    document.querySelectorAll( '.nh-slider' ).forEach( ( slider ) => {
        initNieruchomoscSlider( slider );
    } );
} );
